<template>
  <v-app id="login">
    <v-content>
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <v-flex xs12 sm12 md8>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <v-container fluid fill-height>
                  <img src="@/assets/logo_app.png" height="220" width="auto" class="center" />
                </v-container>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-form @submit.prevent="submit">
                  <v-card class="elevation-12">
                    <v-toolbar dense dark color="blue-grey">
                      <v-toolbar-title>Gastos APP Javer</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text class="pb-0">
                      <v-text-field v-model="username" prepend-icon="person" required :error-messages="usernameErrors"
                        label="Usuario" @input="$v.username.$touch()" @blur="$v.username.$touch()">
                      </v-text-field>
                      <v-text-field v-model="password" type="password" prepend-icon="lock" required
                        :error-messages="passwordErrors" label="Contraseña" @input="$v.password.$touch()"
                        @blur="$v.password.$touch()">
                      </v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <p class="pl-3 grey--text">Frontend {{ frontVersion }} | Backend {{ backVersion }}</p>
                      <v-spacer></v-spacer>
                      <v-btn type="submit" color="blue-grey" :loading="loading" dark>Entrar</v-btn>
                      <v-snackbar v-model="error" color="error" :timeout="2500" bottom>
                        {{ message }}
                      </v-snackbar>
                      <v-dialog v-model="loading" hide-overlay persistent width="300">
                        <v-card color="primary" dark>
                          <v-card-text>
                            Validando información
                            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer height="auto">
      <v-layout justify-center align-center>
        <v-flex xs12 sm12 md8>
          <v-container fluid fill-height>
            <p class="pl-3"><a href="https://www.javer.com.mx/aviso-empleados-administrativos.php" target="_blank">Aviso
                de privacidad</a></p>
            <v-spacer></v-spacer>
            <img src="@/assets/logo_javer.png" height="50" width="auto" />
          </v-container>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
import services from "@/config/services";
import axios from "axios";
import { validationMixin } from "vuelidate";
import { maxLength, required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import pkg from '../../package.json';

export default {
  name: "login",
  mixins: [validationMixin],
  validations: {
    username: {
      required,
      maxLength: maxLength(30)
    },
    password: {
      required,
      maxLength: maxLength(256)
    }
  },
  data: () => ({
    frontVersion: null,
    backVersion: null,
    loading: false,
    error: false,
    message: "",
    username: "",
    password: ""
  }),
  computed: {
    usernameErrors() {
      const errors = [];
      if (!this.$v.username.$dirty) return errors;
      !this.$v.username.required && errors.push("El campo es obligatorio");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.maxLength &&
        errors.push("El campo excede la longitud máxima");
      !this.$v.password.required && errors.push("El campo es obligatorio");
      return errors;
    }
  },
  mounted() {
    this.frontVersion = pkg.version
    this.getBackVersion()
  },
  methods: {
    ...mapActions("general", ["newUser"]),
    clear() {
      this.$v.$reset();
      this.username = "";
      this.password = "";
    },
    async getBackVersion() {
      const { data } = await axios.get(services.routes.backVersion);
      this.backVersion = data.version
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.login();
      }
    },
    login() {
      this.loading = true;
      setTimeout(() => {
        this.axios
          .post(services.routes.login, {
            username: this.username.toLowerCase(),
            password: this.password
          })
          .then(response => {
            let res = response.data;
            if (res.correcto) {
              this.$session.start();
              this.$session.set("userid", res.data.usr_cd);
              this.$session.set("jwt", res.data.token);
              this.newUser({ usr_nm: res.data.usr_nm, roles: res.data.roles });
              const redirect = this.$route.query.redirect;
              const target = redirect && typeof redirect === "string" && redirect.startsWith("/")
                ? redirect
                : "/home";
              this.$router.replace(target);
            } else {
              this.error = true;
              this.message = res.mensaje;
            }
          })
          .catch(error => {
            console.log(error);
            this.error = true;
            this.message =
              "El servicio no se encuentra disponible en estos momentos";
          })
          .finally(() => {
            this.loading = false;
          });
      }, 300);
    }
  }
};
</script>

<style scoped>
img.center {
  display: block;
  margin: 0 auto;
}
</style>
